import { Injectable } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ValidationProvider } from '@services/helpers/validation.service';

@Injectable()
export class ClientServiceProvider {
	constructor(
		private messageService: MessageService,
		private validationService: ValidationProvider
	) {}

	validateClient(client) {
		if (this.validationService.isStringEmpty(client.email.trim())) {
			this.messageService.showToaster('e_1', 'clients');
			return false;
		}

		if (this.validationService.isStringEmpty(client.firstName.trim())) {
			this.messageService.showToaster('e_4', 'clients');
			return false;
		}

		if (!client.companyNameChecked) {
			delete client.companyName;
			delete client.businessNumber;
		}

		const clientToSave = Object.assign({}, client);
		const lowercasedEmail = clientToSave.email.toLowerCase();
		clientToSave.email = lowercasedEmail;
		return clientToSave;
	}

	errorSaveClient(error, client) {
		const { status, data } = error;
		const errorMessage = data.errorMessage;
		let errorCode, errorPlace, value;

		if (status >= 400 && status < 500 && errorMessage) {
			if (
				errorMessage ===
				'Job contact cannot be changed because invoice has Xero payment'
			) {
				errorCode = 'e_10';
				errorPlace = 'xero';
			} else if (errorMessage.includes('already registered')) {
				errorCode = 'e_8';
				errorPlace = 'clients';
				value = client.email;
			} else if (
				errorMessage ===
				'Your QuickBooks company already contains client with such name'
			) {
				errorCode = 'e_6';
				errorPlace = 'qb';
			} else {
				errorCode = 'e_2';
				errorPlace = 'general';
				value = errorMessage;
			}
		} else {
			errorCode = 'e_0';
			errorPlace = 'general';
		}
		this.messageService.showToaster(errorCode, errorPlace, value);
	}

	fillClientSearchText(client) {
		let { email, firstName, id, lastName = ' ' } = client;

		lastName = lastName === null ? ' ' : lastName;

		return {
			id,
			name: `${firstName} ${lastName} (${email})`
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/client/client.service.ts